export const AUTH_LOGIN_REQUEST = "AUTH_LOGIN_REQUEST";
export const AUTH_LOGIN_SUCCESS = "AUTH_LOGIN_SUCCESS";
export const AUTH_LOGIN_FAIL = "AUTH_LOGIN_FAIL";

export const AUTH_LOGOUT_REQUEST = "AUTH_LOGOUT_REQUEST";
export const AUTH_LOGOUT_SUCCESS = "AUTH_LOGOUT_SUCCESS";
export const AUTH_LOGOUT_FAIL = "AUTH_LOGOUT_FAIL";

export const AUTH_AMANAH_REQUEST = "AUTH_AMANAH_REQUEST";
export const AUTH_AMANAH_SUCCESS = "AUTH_AMANAH_SUCCESS";
export const AUTH_AMANAH_FAIL = "AUTH_AMANAH_FAIL";

// Password reset actions
export const FORGOT_PASSWORD_REQUEST = "FORGOT_PASSWORD_REQUEST";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAIL = "FORGOT_PASSWORD_FAIL";

export const VERIFY_RESET_CODE_REQUEST = "VERIFY_RESET_CODE_REQUEST";
export const VERIFY_RESET_CODE_SUCCESS = "VERIFY_RESET_CODE_SUCCESS";
export const VERIFY_RESET_CODE_FAIL = "VERIFY_RESET_CODE_FAIL";

export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAIL = "RESET_PASSWORD_FAIL";